import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AuthenticationService } from 'projects/shared/src/lib/authentication/authentication.service';
import { MobileChromeService } from './core/mobile-chrome.service';
import { RuntimeConfigService } from './core/runtime-config.service';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly authService = inject(AuthenticationService);
  private readonly mobileChromeService = inject(MobileChromeService);
  private readonly runtimeConfigService = inject(RuntimeConfigService);

  constructor() {
    this.authService.getFromLocal();
    this.authService.getFromOnline();
    void this.mobileChromeService.applyThemeChrome();
    void this.runtimeConfigService.loadActiveConfig();
  }
}
